import { axiosInstance } from '../../api';
const BASE_PATH = '/one_way_interview_templates';

//Create One Way Interview Template API Call
export let createOneWayInterviewTemplate = async (name, max_attempts_per_ques ) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/create_one_way_interview_template', {
            template_name: name,
            max_attempts_per_ques: max_attempts_per_ques,
        })
        return value;
    } catch (error) {
        return error
    }
}

//Get Quiz details API call
export let getAllOneWayInterviewTemplates = async (state) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_one_way_interview_templates', {
            one_way_interview_template_state: state
        })
        return value
    } catch (error) {
        return error
    }
}

//Get Pipeline API Call
export let getOneWayInterviewTemplate = async (oneWayInterviewTemplateID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_one_way_interview_template', {
            one_way_interview_template_id: oneWayInterviewTemplateID
        })
        return value
    } catch (error) {
        return error
    }
}

export let getOneWayInterviewDetailsToPipelineStages = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_one_way_interview_templates_to_add_to_pipeline_step');
        return value
    } catch (error) {
        return error
    }
}

export let addQuestionToOneWayInterviewTemplate = async (question_values, one_way_interview_templete_id) => {
    try {
        let values = await axiosInstance.post(BASE_PATH + '/add_question_to_one_way_interview_template', {
            one_way_interview_template_id: one_way_interview_templete_id,
            message: question_values.message,
            ans_min: question_values.ans_min,
        })
        return values
    } catch (err) {
        return err;
    }
}

export let editQuestionToOneWayInterviewTemplate = async (question_values, one_way_interview_templete_id, question_id) => {
    try {
        let values = await axiosInstance.post(BASE_PATH + '/edit_question_in_one_way_interview_template', {
            one_way_interview_template_id: one_way_interview_templete_id,
            question_id: question_id,
            message: question_values.message,
            ans_min: question_values.ans_min,
        })
        return values
    } catch (err) {
        return err;
    }
}

export let editBaseDataOnOneWayInterviewTemplate = async (one_way_interview_templete_id, name, max_attempts_per_ques ) => {
    try {
        let values = await axiosInstance.post(BASE_PATH + '/edit_base_data_in_one_way_interview_template', {
            one_way_interview_template_id: one_way_interview_templete_id,
            template_name: name,
            max_attempts_per_ques : max_attempts_per_ques,
        })
        return values
    } catch (err) {
        return err;
    }
}

export let editOneWayInterviewTemplate = async (one_way_interview_template_id,questions) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/edit_one_way_interview_template', {
            one_way_interview_template_id: one_way_interview_template_id,
            questions: questions,
        })
        return value;
    } catch (error) {
        return error
    }
}

export let activateOneWayInterviewTemplate = async (template_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/activate_one_way_interview_template', {
            one_way_interview_template_id: template_id,
        })
        return value
    } catch (error) {
        return error
    }
}


export let disableOneWayInterviewTemplate = async (template_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/disable_one_way_interview_template', {
            one_way_interview_template_id: template_id,
        })
        return value
    } catch (error) {
        return error
    }
}

export let deleteQuestionFromOneWayInterview = async (template_id, ques_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/remove_question_from_one_way_interview_template', {
            one_way_interview_template_id: template_id,
            question_id: ques_id
        })
        return value
    } catch (error) {
        return error
    }
}

export let putBackToDraft = async (template_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/put_back_to_draft_mode_one_way_interview_template', {
            one_way_interview_template_id: template_id,
        })
        return value
    } catch (error) {
        return error
    }
}

export let copyOneWayInterviewTemplateToANew = async (template_id, template_name) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/copy_one_way_interview_template_to_a_new', {
            one_way_interview_template_id: template_id,
            new_one_way_interview_template_name: template_name,
        })
        return value
    } catch (error) {
        return error
    }
}

export let checkIfTemplateEligibleToDisableOrPutBackToEdit = async (template_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/check_one_way_interview_template_eligible_to_make_disable_or_draft', {
            one_way_interview_template_id: template_id,
        })
        return value
    } catch (error) {
        return error
    }
}

export let changeQuestionOrder = async (template_id, questionArray) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/change_one_way_interview_question_order', {
            one_way_interview_template_id: template_id,
            question_array: questionArray,
        })
        return value
    } catch (error) {
        return error
    }
}

export let checkingOneWayInterviewTemplateActive = async (template_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/checking_one_way_interview_active', {
            one_way_interview_template_id: template_id,
        })
        return value
    } catch (error) {
        return error
    }
}

